<template>
  <div class="menu">
    <el-aside width="200px">
      <!-- <div class="logo clearfix" v-if="headOne"> -->
        <!-- <span class="left logoImg"><img :src="head"></span> -->
       <!-- <span class="left brandName">体育联盟</span>-->
      <!-- </div> -->
      <!-- <div class="logo clearfix"  v-if="headTwo">
        <span class="left brandName" style="text-align: center;width: 100%">体质健康服务平台</span>

      </div> -->
      <el-menu
        class="el-menu-vertical-demo"

        text-color="#000"
        active-text-color="#7c7c7c"
        router
        @open="handleOpen"
        @close="handleClose"
      >
        <el-submenu :index="String(index)" v-for="(menu,index) in menuList" :key="menu.id" class="myClass">
          <template slot="title"><i :class="menu.showIcon" :id="['showIcon' + index]"></i><i :class="menu.icon" class="iconfont"></i>{{menu.name}}</template>
          <el-menu-item :index="menu.children[i].url" v-for="(subMenu,i) in menu.children" :key="subMenu.id" class="comItem">
            {{subMenu.name}}
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
  </div>
</template>

<script>
  import $ from 'jquery'
  // import layer from 'layer'
  import {baseUrl, ERR_OK, head} from 'common/api/api'

  export default {
    data() {
      return {
        showE:null,
        showI:null,
        openeds: ['0','1','2','3','4','5','6','7','8','9','10','11','12'],
        icon:'arrow',
        headOne: false,
        headTwo: false,
        head: head,
        api: {
          menuList: '/api/common/user/menus'
        },
        screenHeight: $(window).height() - 60,
        menuList: []
      }
    },
    created() {
      this.$nextTick(() => {
      })
    },
    mounted() {
      this._getMenu()
      if (head === './static/images/headTwo.png') {
        this.headTwo = true
      } else {
        this.headOne = true
      }
    },
    methods: {
      handleOpen(index){
        let si = 'showIcon' + index
        document.getElementById(si).setAttribute("class", "arrowDown")
      },
      handleClose(index){
        let si = 'showIcon' + index
        document.getElementById(si).setAttribute("class", "arrow")
      },
      /**
       * 获取左边主菜单
       *
       */
      _getMenu() {
        this.$http({
          method: 'POST',
          url: baseUrl + this.api.menuList,
          emulateJSON: true,
          _timeout: 6000,
          onTimeout: (request) => {
          }
        }).then(function (res) {
          let response = res.body
          if (response.code === ERR_OK) {
            this.menuList = response.data.children
            for(let i= 0;i<response.data.children.length;i++){
              response.data.children[i].showIcon = 'arrow'
            }
            // this.menuList = response.data.children
          }
        })
      }
    },
    watch: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-submenu__icon-arrow .el-icon-arrow-down{
    color: #222 !important;
    display: none!important;
  }
  .el-icon-arrow-down::before{
    color: #222!important;
    display: none!important;
  }
  .itemActive{
    background:#a0d4ff !important;
    color: #fff !important;
    // border-radius: 10px !important;
  }
  .arrowDown{
    width:0;
    position: absolute;
    top:50%;
    margin-top: -3px;
    left:18px;
    -webkit-transform:rotate(90deg);
    border-left: solid 4px #222;
    border-top:solid 4px transparent;
    border-bottom:solid 4px transparent;
    -webkit-transition:all 0.25s ease-in-out
  }
  .arrow{
    width:0;
    position: absolute;
    top:50%;
    margin-top: -3px;
    left:18px;
    border-left: solid 4px #222;
    border-top:solid 4px transparent;
    border-bottom:solid 4px transparent;
    -webkit-transition:all 0.25s ease-in-out
  }
  .el-submenu__icon-arrow .el-icon-arrow-down{
    left:0px!important;
  }
  .comItem{
    padding-left: 79px!important;
    position: relative;
  }
  .is-active::before{
    background-color:#fff!important;
  }
  .is-active::after{
    border-color:#fff!important;
  }
  // .comItem::before{
  //   position: absolute;
  //   top:0;
  //   left:52px;
  //   content: '';
  //   width: 1px;
  //   height:100%;
  //   background: #222;
  //   opacity: .3;
  // }
  .el-icon-arrow-down:before{
    content: ""!important;
  }
  .comItem::after{
    position: absolute;
    top:50%;
    left:52px;
    content: '';
    width: 6px;
    height:6px;
    border:1px solid #222;
    box-sizing: border-box;
    border-radius: 100%;
    margin-top: -3px;
    margin-left: -3px;
  }
  .menu {
    height:100%;
    background:#fff;
    // padding:0 10px 0 10px !important;
    border-right: 1px solid #d1d2d4;
    .iconfont {
      color: #222;
      margin-right: 20px;
      position: relative;
      top: -1px;
      margin-left: 24px;
    }
    .logo {
      font-size: 16px;
      height: 60px;
      background-color: #282A3C;
      .logoImg {
        /*margin-left: 25px;
        margin-top: 13px;
        margin-right: 5px;*/
        text-align: center;
        width:100%;
        display: block;
        img {
          width: 110px;
          height: 50px;
          margin-top: 6px;
        }
      }
      .brandName {
        color: #fff;
        line-height: 60px;
      }
    }
    .el-menu {
      border-right: 0;
      height: -webkit-calc(100% - (60px));
      height: -moz-calc(100% - (60px));
      height: calc(100% - (60px));
    }
    .el-submenu__title{
      border-radius: 10px !important;
    }

  }

  .el-aside {
    color: #333;
  }
  .el-menu--inline{
    background-color: #dfe1e2 !important;
  }
  .myClass{
      border-radius: 10px !important;
    }
  .el-menu-item{
    border-radius: 10px !important;
  }
  // .el-menu-item:hover{
  //   background-color: #fcd6b9 !important;
  // }
  .el-submenu{
    border-radius: 10px !important;
  }
  .el-submenu>div{
    border-radius: 10px;
  }
  .el-menu-vertical-demo,.el-menu{
    height: 100%;
   background-color: #fff!important;
 }

html{
  -ms-overflow-style:none;
  overflow:-moz-scrollbars-none;
}

::-webkit-scrollbar{
  display:none;
}

</style>



// WEBPACK FOOTER //
// src/components/menu/menu.vue